import { setPrimaryTracker } from 'usage-tracker-container'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Ap... Remove this comment to see the full error message

import App from './App'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './ut... Remove this comment to see the full error message

import * as usageTracker from './utils/usageTracker';
setPrimaryTracker(usageTracker);
new App().start();